import { Entity } from './entity.class';
import { Leave } from './leave';
import { PlanningHasEntity } from './planning-has-entity.class';
import { Planning } from './planning.class';
import { Project } from './project.class';
import { Settlement } from './settlement.class';
import { UserPlanning } from './user-planning';
import { User } from './user.class';

export class Realisation {
    id?: number;
    bookdate: Date;
    begindate: Date;
    enddate: Date;
    travel?: boolean;
    user_id: number;
    parent_realisation_id?: number;
    user?: User;
    entity_id?: number;
    entity?: Entity;
    planning_id: number;
    planning?: Planning;
    planning_has_entity_id?: number;
    planning_has?: PlanningHasEntity;
    user_planning?: UserPlanning;
    user_planning_id?: number;
    afas_project_id?: string;
    adjusted?: Date;
    submitted?: Date;
    confirmed?: Date;
    approved?: Date;
    removed?: Date;
    skip_performer?: boolean;
    performer_forward_deadline_at?: Date;
    paid?: Date;
    performer_id?: number;
    kms?: number;
    pause?: number;
    pause_adjusted?: boolean;
    saved_by_id?: number;
    removed_by_id?: number;
    comment_user?: string;
    comment_user_approved?: string;
    comment_user_approved_handled?: Date;
    comment_manager?: string;
    created_at?: Date;
    updated_at?: Date;
    deleted_at?: Date;

    dayOff?: boolean;
    dayOffReason?: string;

    hourtype?: RealisationHourtype;
    text_prepend?: string;
    text_append?: string;
    traveltime?: number;

    hiring_name?: string;

    settlements?: Settlement[];
    project?: Project;

    leave_id?: number;
    leave?: Leave;
}

export enum RealisationHourtype {
    additional_parental = 'additional_parental',
    bank_holiday = 'bank_holiday',
    day_off = 'day_off',
    driving_back = 'driving_back',
    driving_to = 'driving_to',
    education = 'education',
    frost = 'frost',
    illness = 'illness',
    loading_unloading = 'loading_unloading',
    not_available = 'not_available',
    paid_leave = 'paid_leave',
    repair_maintenance = 'repair_maintenance',
    short_absence = 'short_absence',
    sleep = 'sleep',
    special_leave = 'special_leave',
    time_for_time = 'time_for_time',
    travel_back = 'travel_back',
    travel_to = 'travel_to',
    worktime = 'worktime',
    zzp_leave = 'zzp_leave',
}
